import React from 'react';
import { Space, Button, Typography, message, Tooltip } from 'antd';
import { CopyOutlined, LinkOutlined } from '@ant-design/icons';

const { Link } = Typography;

interface URLDisplayProps {
  url: string;
  maxLength?: number;
}

export const URLDisplay: React.FC<URLDisplayProps> = ({ url, maxLength = 50 }) => {
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      message.success('URL copied to clipboard');
    } catch (error) {
      message.error('Failed to copy URL');
    }
  };

  // Truncate URL if it's too long
  const displayUrl = url.length > maxLength ? `${url.substring(0, maxLength)}...` : url;

  return (
    <Space size="small">
      <Tooltip title={url}>
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ maxWidth: 300, display: 'inline-block' }}
          ellipsis
        >
          {displayUrl}
        </Link>
      </Tooltip>
      <Tooltip title="Copy URL">
        <Button
          type="text"
          size="small"
          icon={<CopyOutlined />}
          onClick={copyToClipboard}
        />
      </Tooltip>
      <Tooltip title="Open in new tab">
        <Button
          type="text"
          size="small"
          icon={<LinkOutlined />}
          href={url}
          target="_blank"
        />
      </Tooltip>
    </Space>
  );
};
